import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro de la factura PDF de Canva -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// Anclas verificadas sobre el texto real de pdfjs. Obligatorios (throw): folio, monto.
// fecha/unidades best-effort -> null si no matchean. periodo: derivado de `fecha` (regla sistemica).
export const parsearCanvaDesdeTexto = (texto) => {
  // folio: tras "Invoice #:" -> "04926-81147406-1" (digitos y guiones). Ancla obligatoria.
  const mFolio = texto.match(/Invoice #:\s*(\d[\d-]+)/);
  if (!mFolio) throw new Error("No se reconoce el formato de factura Canva (falta Invoice #)");
  const folio = mFolio[1];

  // monto: ULTIMA ocurrencia de "USD <num>" (formato US: coma miles, punto decimal) -> 20.00. Obligatorio.
  const montos = [...texto.matchAll(/USD\s+([\d,]+\.\d{2})/g)];
  if (montos.length === 0) throw new Error("No se pudo leer el monto de la factura Canva");
  const monto = Number(montos.at(-1)[1].replace(/,/g, ""));

  // fecha: tras "Invoice date:" -> "June 28, 2026" (Month DD, YYYY). Best-effort.
  const mFecha = texto.match(/Invoice date:\s*([A-Za-z]+\s+\d{1,2},\s*\d{4})/);
  const fecha = mFecha ? parseFecha(mFecha[1]) : null;

  // concepto: tras "Subscription:" -> "Canva for Teams" (frena antes del primer digito / bloque MAYUS).
  const mConcepto = texto.match(/Subscription:\s*([A-Za-z][ A-Za-z]+?)(?=\s+\d|\s+[A-Z]{3,}\b|$)/);
  const concepto = mConcepto ? mConcepto[1].trim() : "";

  // unidades: QUANTITY de la linea de suscripcion, escrita como "1.0" -> 1. Best-effort.
  const mUnidades = texto.match(/\b(\d+)\.0\b/);
  const unidades = mUnidades ? Number(mUnidades[1]) : null;

  // periodo: derivado de `fecha` (regla sistemica) -> 2026-06-01 desde fecha 2026-06-28.
  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto, monto, moneda: "USD", unidades };
};
